import React from 'react'
import { useAdminAuth } from '../context/AdminAuthContext'

function Header() {

   const { admin, logout } = useAdminAuth();

   return (
      <>
      <div class="position-relative ">
               <nav class="nav navbar navbar-expand-xl navbar-light iq-navbar header-hover-menu left-border">
                  <div class="container-fluid navbar-inner">
                     <a href="/" class="navbar-brand">
                        <div class="logo-main">
                           <div class="logo-normal">
                              <img src='../../assets/images/v-union-.svg' style={{width:'20%'}}></img>
                           </div>
                           <div class="logo-mini">
                              <img src='../../assets/images/v-union-.svg' style={{width:'20%'}}></img>
                           </div>
                        </div>
                        
                     </a>
                     <div class="sidebar-toggle" data-toggle="sidebar" data-active="true">
                        <i class="icon d-flex">
                           <svg class="icon-20" width="20" viewBox="0 0 24 24">
                              <path fill="currentColor" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                           </svg>
                        </i>
                     </div>
                     <div class="d-flex align-items-center justify-content-between product-offcanvas">
                        <div class="breadcrumb-title border-end me-3 pe-3 d-none d-xl-block">
                           <small class="mb-0 text-capitalize"></small>
                        </div>

                        <div class="offcanvas offcanvas-end shadow-none iq-product-menu-responsive" tabindex="-1" id="offcanvasBottom">
                           <div class="offcanvas-body">
                              <ul class="iq-nav-menu list-unstyled">
                                 <li class="nav-item active">
                                    <a class="nav-link menu-arrow justify-content-start" href="/">
                                       <svg width="20" class="icon-20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path opacity="0.4"
                                             d="M16.0756 2H19.4616C20.8639 2 22.0001 3.14585 22.0001 4.55996V7.97452C22.0001 9.38864 20.8639 10.5345 19.4616 10.5345H16.0756C14.6734 10.5345 13.5371 9.38864 13.5371 7.97452V4.55996C13.5371 3.14585 14.6734 2 16.0756 2Z"
                                             fill="currentColor"></path>
                                          <path fill-rule="evenodd" clip-rule="evenodd"
                                             d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                                             fill="currentColor"></path>
                                       </svg>
                                       <span class="nav-text ms-2">Panel</span>
                                    </a>

                                    {/* <ul class="iq-header-sub-menu list-unstyled collapse" id="homeData">
                                       <li class="nav-item"><a class="nav-link active"
                                             href="/">Dashboard</a></li>
                                       <li class="nav-item"><a
                                             class="nav-link "
                                             href="../dashboard/alternate-dashboard.html">Alternate Dashboard</a></li>
                                       <li class="nav-item">
                                          <a class="nav-link menu-arrow" data-bs-toggle="collapse" href="#menuStyles" role="button"
                                             aria-expanded="false" aria-controls="menuStyles">
                                             Menu Style
                                             <i class="right-icon">
                                                <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none"
                                                   xmlns="http://www.w3.org/2000/svg">
                                                   <path d="M8.5 5L15.5 12L8.5 19" stroke="currentColor" strokeWidth="1.5"
                                                      stroke-linecap="round" stroke-linejoin="round"></path>
                                                </svg>
                                             </i>
                                          </a>
                                          <ul aria-expanded="false" class="iq-header-sub-menu left list-unstyled collapse"
                                             id="menuStyles">
                                             <li class="nav-item"><a
                                                   class="nav-link "
                                                   href="../dashboard/index-horizontal.html">Horizontal Dashboard</a></li>
                                             <li class="nav-item"><a
                                                   class="nav-link "
                                                   href="../dashboard/index-dual-horizontal.html">Dual Horizontal Dashboard</a>
                                             </li>
                                             <li class="nav-item"><a
                                                   class="nav-link "
                                                   href="../dashboard/index-dual-compact.html">Dual Compact</a></li>
                                             <li class="nav-item"><a
                                                   class="nav-link "
                                                   href="../dashboard/index-boxed.html">Boxed Horizontal</a></li>
                                             <li class="nav-item"><a
                                                   class="nav-link "
                                                   href="../dashboard/index-boxed-fancy.html">Boxed Fancy</a></li>
                                          </ul>
                                       </li>
                                    </ul> */}
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </div>
                     <div class="d-flex align-items-center">
                        <button id="navbar-toggle" class="navbar-toggler" type="button" data-bs-toggle="collapse"
                           data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                           aria-label="Toggle navigation">
                           <span class="navbar-toggler-icon">
                              <span class="navbar-toggler-bar bar1 mt-1"></span>
                              <span class="navbar-toggler-bar bar2"></span>
                              <span class="navbar-toggler-bar bar3"></span>
                           </span>
                        </button>
                     </div>
                     <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="mb-2 navbar-nav ms-auto align-items-center navbar-list mb-lg-0">

                           <li class="nav-item dropdown" id="itemdropdown1">
                              <a class="py-0 nav-link d-flex align-items-center" href="#" id="navbarDropdown" role="button"
                                 data-bs-toggle="dropdown" aria-expanded="false">
                                 <div class="btn btn-primary btn-icon btn-sm rounded-pill">
                                    <span class="btn-inner">
                                       <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none"
                                          xmlns="http://www.w3.org/2000/svg">
                                          <path
                                             d="M11.997 15.1746C7.684 15.1746 4 15.8546 4 18.5746C4 21.2956 7.661 21.9996 11.997 21.9996C16.31 21.9996 19.994 21.3206 19.994 18.5996C19.994 15.8786 16.334 15.1746 11.997 15.1746Z"
                                             fill="currentColor"></path>
                                          <path opacity="0.4"
                                             d="M11.9971 12.5838C14.9351 12.5838 17.2891 10.2288 17.2891 7.29176C17.2891 4.35476 14.9351 1.99976 11.9971 1.99976C9.06008 1.99976 6.70508 4.35476 6.70508 7.29176C6.70508 10.2288 9.06008 12.5838 11.9971 12.5838Z"
                                             fill="currentColor"></path>
                                       </svg>
                                    </span>
                                 </div>
                              </a>
                              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                                 <li>
                                    <a class="dropdown-item" href="/">Perfil</a>
                                 </li>
                                 <li>
                                    <hr class="dropdown-divider"/>
                                 </li>
                                 <li>
                                    <a class="dropdown-item" onClick={logout}>Cerrar Sesión</a>
                                 </li>
                              </ul>
                           </li>
                           <li class="nav-item iq-full-screen d-none d-xl-block" id="fullscreen-item">
                              <a href="#" class="nav-link" id="btnFullscreen" data-bs-toggle="dropdown">
                                 <div class="btn btn-primary btn-icon btn-sm rounded-pill">
                                    <span class="btn-inner">
                                       <svg class="normal-screen icon-24" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                          xmlns="http://www.w3.org/2000/svg">
                                          <path d="M18.5528 5.99656L13.8595 10.8961" stroke="white" strokeWidth="1.5"
                                             stroke-linecap="round" stroke-linejoin="round"></path>
                                          <path d="M14.8016 5.97618L18.5524 5.99629L18.5176 9.96906" stroke="white" strokeWidth="1.5"
                                             stroke-linecap="round" stroke-linejoin="round"></path>
                                          <path d="M5.8574 18.896L10.5507 13.9964" stroke="white" strokeWidth="1.5"
                                             stroke-linecap="round" stroke-linejoin="round"></path>
                                          <path d="M9.60852 18.9164L5.85775 18.8963L5.89258 14.9235" stroke="white" strokeWidth="1.5"
                                             stroke-linecap="round" stroke-linejoin="round"></path>
                                       </svg>
                                       <svg class="full-normal-screen d-none icon-24" width="24" height="24" viewBox="0 0 24 24"
                                          fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M13.7542 10.1932L18.1867 5.79319" stroke="white" strokeWidth="1.5"
                                             stroke-linecap="round" stroke-linejoin="round"></path>
                                          <path d="M17.2976 10.212L13.7547 10.1934L13.7871 6.62518" stroke="currentColor"
                                             strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                          <path d="M10.4224 13.5726L5.82149 18.1398" stroke="white" strokeWidth="1.5"
                                             stroke-linecap="round" stroke-linejoin="round"></path>
                                          <path d="M6.74391 13.5535L10.4209 13.5723L10.3867 17.2755" stroke="currentColor"
                                             strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                       </svg>
                                    </span>
                                 </div>
                              </a>
                           </li>
                        </ul>
                     </div>
                  </div>
               </nav>          
         </div>
      </>
   )
}

export default Header